import { Component, OnInit } from '@angular/core';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AlertService } from '../alert.service';
import { SettingService } from '../setting.service';
import { NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-settings-proposals-agreement-types',
  templateUrl: './settings-proposals-agreement-types.component.html',
  styleUrls: ['./settings-proposals-agreement-types.component.css'],
  imports: [ReactiveFormsModule, FaIconComponent]
})
export class SettingsProposalsAgreementTypesComponent implements OnInit {

  // Properties
  multiAgreementTypeForm: FormGroup;

  // Font Awesome Properties
  faSave = faSave;

  constructor(private settingService: SettingService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.multiAgreementTypeForm = new FormGroup({
      A: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      B: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      C: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      D: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      E: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      })
    });
    this.getMultiAgreementTypeOptions();
  }

  // Get Multi Agreement Type Options
  private getMultiAgreementTypeOptions(): void {
    this.settingService.getMultiAgreementTypeOptions().subscribe((options) => {
      for (const property in options) {
        (this.multiAgreementTypeForm.controls[property] as FormGroup).controls['isEnabled'].setValue(options[property].isEnabled);
        (this.multiAgreementTypeForm.controls[property] as FormGroup).controls['numOfYears'].setValue(options[property]?.numOfYears ?? null);
      }
    });
  }

  // Update Multi Agreement Type Options
  updateMultiAgreementTypeOptions(): void {
    this.settingService.updateMultiAgreementTypeOptions(this.multiAgreementTypeForm.value).subscribe(() => {
      this.alertService.showSuccessAlert('Agreement Types Updated');
      this.getMultiAgreementTypeOptions();
    });
  }
}
